/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const FILTER_LINES_VIEWBOX_W = 9;
const FILTER_LINES_VIEWBOX_H = 6;

const FILTER_LINES_PATH = 'M3.5 6V5H5.5V6H3.5ZM1.5 3.5V2.5H7.5V3.5H1.5ZM0 1V0H9V1H0Z';

const iconPropTypes = {
  /** Width in px; height scales to preserve 9×6 aspect ratio. */
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Compact filter lines (9×6). Color via `fill` or CSS `color` + `currentColor`. */
const FilterLinesIcon = ({
  size = 16,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = Math.round((size * FILTER_LINES_VIEWBOX_H) / FILTER_LINES_VIEWBOX_W);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${FILTER_LINES_VIEWBOX_W} ${FILTER_LINES_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={FILTER_LINES_PATH} fill={fill} />
    </svg>
  );
};

FilterLinesIcon.propTypes = iconPropTypes;

export { FilterLinesIcon };
export default FilterLinesIcon;
